import { useLazyAbnLookupQuery } from '../services/abn';
import { abnSlice } from '../slices/abn';
import { useAppDispatch, useAppSelector } from './useSelectors';

export const useAbn = () => {
  const dispatch = useAppDispatch();
  const [triggerAbnLookup] = useLazyAbnLookupQuery();
  const { number: abn, noAbn } = useAppSelector((state) => state.abn);
  const { businessNameLookup } = useAppSelector((state) => state.abn);

  return {
    number: abn,
    noAbn,
    businessNameLookup,
    triggerAbnLookup,
    setAbn: (value: string) => dispatch(abnSlice.actions.updateAbn(value)),
    setNoAbn: (value: boolean) => dispatch(abnSlice.actions.updateNoAbn(value)),
  };
};
